'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var isAfterDay = {};

exports.__exports = isAfterDay;
